export default String.raw`
<g id="Zalogowany">
    <g id="Frame 217">
        <g id="Belka z reklama">
            <rect width="1440" height="48" class="topBannerBgColor"/>
            <text id="Reklama" class="topBannerFontColor" xml:space="preserve" style="white-space: pre"  font-size="14" font-weight="500" letter-spacing="0px">
                <tspan x="691.631" y="29.0909">TRANSLATION_Prv_Advertisement</tspan>
            </text>
        </g>
        <g id="Frame 11">
            <rect width="1440" height="40" transform="translate(0 48)" class="bgColor"/>
            <g id="Frame 42">
                <g id="4. Text Button">
                    <g id="Interface/Headphones" transform="translate(135.000000, 58.000000)">
                        <use class="hoverOverButton--stroke" xlink:href="#headset" width="19" height="19"></use>    
                    </g>
                    <text id="Text" class="primaryColorFont" xml:space="preserve" style="white-space: pre"  font-size="14" letter-spacing="0px">
                        <tspan x="158.468" y="73.0909">12 681 43 00</tspan>
                    </text>
                </g>
                <g id="4. Text Button_2">
                    <g id="Interface/Mail" transform="translate(263.000000, 58.000000)">
                        <use class="hoverOverButton--stroke" xlink:href="#envelope" width="19" height="19"></use>
                    </g>
                    <text id="Text_2" class="primaryColorFont" xml:space="preserve" style="white-space: pre"  font-size="14" letter-spacing="0px">
                        <tspan x="289.185" y="73.0909">e-sklep-test@comarch.pl</tspan>
                    </text>
                </g>
            </g>
            <g id="Frame 221">
                <g id="Text button ">
                    <text id="Text_3" class="primaryColorFont" xml:space="preserve" style="white-space: pre"  font-size="14" letter-spacing="0px">
                        <tspan x="1017.15" y="73.0909">Comarch S.A.</tspan>
                    </text>
                    <g id="Arrows/chevron down" transform="translate(1112.000000, 62.000000)">
                        <use class="hoverOverButton--stroke" xlink:href="#chevron-down" width="12" height="12"></use>
                    </g>
                </g>
                <g id="Frame 43">
                    <g id="Text button _2">
                        <text id="Text_4" class="primaryColorFont" xml:space="preserve" style="white-space: pre"  font-size="14" letter-spacing="0px">
                            <tspan x="1167.35" y="73.0909">PLN</tspan>
                        </text>
                        <g id="Arrows/chevron down_2" transform="translate(1205.000000, 62.000000)">
                            <use class="hoverOverButton--stroke" xlink:href="#chevron-down" width="12" height="12"></use>
                        </g>
                    </g>
                    <g id="Frame 207">
                        <g id="Icons/24/Flags/pl">
                            <rect id="rectangle" x="0.5" y="-0.5" width="15" height="6" transform="matrix(1 0 0 -1 1243 68)" fill="white" stroke="#DADADA"/>
                            <rect id="rectangle_2" x="1243" y="68" width="16" height="6" fill="#CD4040"/>
                        </g>
                        <g id="Text button _3">
                            <text id="Text_5" class="primaryColorFont" xml:space="preserve" style="white-space: pre"  font-size="14" letter-spacing="0px">
                                <tspan x="1265.12" y="73.0909">PL</tspan>
                            </text>
                            <g id="Arrows/chevron down_3" transform="translate(1292.000000, 62.000000)">
                                <use class="hoverOverButton--stroke" xlink:href="#chevron-down" width="12" height="12"></use>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <line id="Divider" y1="87.5" x2="1440" y2="87.5" stroke="#E7E7E7"/>
        <g id="Frame 2">
            <rect width="1440" height="88" transform="translate(0 88)" class="bgColor"/>
            <image id="logo" x="132" y="114" href="./img/logo_comarch_esklep.png" height="37" width="116" />
            <g id="1. Search - Basic">
                <rect x="288.647" y="112.5" width="564.853" height="39" rx="4.5" class="bgColor" stroke="#D5D5D5"/>
                <text id="Szukaj po nazwie, indeksie, producencie..." fill="#767676" xml:space="preserve" style="white-space: pre"  font-size="14" letter-spacing="0px">
                    <tspan x="304.147" y="137.091">TRANSLATION_Prv_HeaderSearchPlaceholder</tspan>
                </text>
            <g id=".x/Search button">
                <rect id="Rectangle 166" x="814" y="116" width="1" height="32" fill="#F3F3F3"/>
                <g id="Interface/Search" transform="translate(824.000000, 122.000000)">
                    <use class="primaryColor--stroke" xlink:href="#search" width="19" height="19"></use>
                </g>
            </g>
        </g>
        <g id="Nawigacja naglowka/Default">
            <g id="4. Text Button_3">
                <g id="Interface/User" transform="translate(930.000000, 110.000000)">
                    <use class="primaryColor--stroke" xlink:href="#user" width="19" height="19"></use>
                </g>
                <foreignObject x="891" y="132" width="97" height="32">
                    <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                        <span class="primaryColorFont" style="font-size: 11px; font-weight: 500; text-align: center; line-height: 1.2;">TRANSLATION_Prv_ClientPanel</span>
                    </div>
                </foreignObject>
            </g>
            <g id="4. Text Button_5">
                <g id="Interface/clipboard" transform="translate(1035.000000, 110.000000)">
                    <use class="primaryColor--stroke" xlink:href="#clipboard-list" width="19" height="19"></use>
                </g>
                <foreignObject x="1001" y="132" width="87" height="32">
                    <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                        <span class="primaryColorFont" style="font-size: 11px; font-weight: 500; text-align: center; line-height: 1.2;">TRANSLATION_Prv_WishList</span>
                    </div>
                </foreignObject>
            </g>
            <g id="4. Text Button_7">
                <g id="Interface/Invoice" transform="translate(1141.000000, 110.000000)">
                    <use class="primaryColor--stroke" xlink:href="#file-invoice-dollar" width="19" height="19"></use>
                </g>
                <foreignObject x="1097" y="132" width="107" height="32">
                    <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                        <span class="primaryColorFont" style="font-size: 11px; font-weight: 500; text-align: center; line-height: 1.2;">TRANSLATION_Prv_RequestForQuote</span>
                    </div>
                </foreignObject>
            </g>
            <g id="4. Text Button_9">
                <g id="Frame 173">
                    <g id="shopping-cart-icon" transform="translate(1218.000000, 110.000000)">
                        <use class="primaryColor--stroke" xlink:href="#shopping-cart" width="19" height="19"></use>
                    </g>
                    <text id="Text_9" class="primaryColorFont" xml:space="preserve" style="white-space: pre"  font-size="10" font-weight="500" letter-spacing="0px">
                        <tspan x="1240.81" y="123.636">164 859,61 z&#x142;</tspan>
                    </text>
                    <g id="Interface/Number">
                        <rect x="1227" y="101" width="16" height="16" rx="8" class="headerCounterBgColor"/>
                        <text id="2" class="headerCounterFontColor" xml:space="preserve" style="white-space: pre"  font-size="11" letter-spacing="0px">
                            <tspan x="1231.5" y="113">9</tspan>
                        </text>
                    </g>
                </g>
                <foreignObject x="1218" y="132" width="100" height="32">
                    <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                        <span class="primaryColorFont" style="font-size: 11px; font-weight: 500; text-align: center; line-height: 1.2;">TRANSLATION_Prv_Cart 1</span>
                    </div>
                </foreignObject>
            </g>
        </g>
    </g>
    <line id="Divider_2" y1="175.5" x2="1440" y2="175.5" class="lightBorderColor--stroke"/>
    <g id="Frame 216">
        <rect width="1440" height="44" transform="translate(0 176)" class="menuBackgroundColor"/>
        <g id="Divider Vertical">
            <line id="Divider_3" x1="129.5" y1="210" x2="129.5" y2="186" class="lightBorderColor--stroke" stroke-opacity="0.5"/>
        </g>
        <g id="Frame 175">
            <g id="Frame 179">
                <g id="Navigation/Hamburger menu" transform="translate(148.000000, 188.000000)">
                    <use class="primaryColorFont--stroke" xlink:href="#bars" width="19" height="19"></use>
                </g>
                <foreignObject x="173" y="182" width="100" height="36">
                    <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                        <span class="primaryColorFont" style="font-size: 14px; font-weight: 600; text-align: center; line-height: 1.2;">TRANSLATION_Prv_Categories</span>
                    </div>
                </foreignObject>
            </g>
        </g>
        <g id="Divider Vertical_2">
            <line id="Divider_4" x1="281.5" y1="210" x2="281.5" y2="186" class="lightBorderColor--stroke" stroke-opacity="0.5"/>
        </g>
        <foreignObject x="290" y="182" width="92" height="36">
            <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                <span class="primaryColorFont" style="font-size: 14px; font-weight: 600; text-align: center; line-height: 1.2;">TRANSLATION_Prv_Manufacturers</span>
            </div>
        </foreignObject>
        <g id="Divider Vertical_3">
            <line id="Divider_5" x1="390.5" y1="210" x2="390.5" y2="186" class="lightBorderColor--stroke" stroke-opacity="0.5"/>
        </g>
        <foreignObject x="398" y="182" width="224" height="36">
            <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                <span class="primaryColorFont" style="font-size: 14px; font-weight: 600; text-align: center; line-height: 1.2;">TRANSLATION_Prv_AdvancedSearch</span>
            </div>
        </foreignObject>
        <g id="Divider Vertical_4">
            <line id="Divider_6" x1="630.5" y1="210" x2="630.5" y2="186" class="lightBorderColor--stroke" stroke-opacity="0.5"/>
        </g>
        <foreignObject x="638" y="182" width="136" height="36">
            <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                <span class="primaryColorFont" style="font-size: 14px; font-weight: 600; text-align: center; line-height: 1.2;">TRANSLATION_Prv_ImportCart</span>
            </div>
        </foreignObject>
        <g id="Divider Vertical_5">
            <line id="Divider_7" x1="782.5" y1="210" x2="782.5" y2="186" class="lightBorderColor--stroke" stroke-opacity="0.5"/>
        </g>
        <foreignObject x="790" y="182" width="220" height="36">
            <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                <span class="primaryColorFont" style="font-size: 14px; font-weight: 600; text-align: center; line-height: 1.2;">TRANSLATION_Prv_DownloadCSV</span>
            </div>
        </foreignObject>
        <g id="Divider Vertical_6">
            <line id="Divider_8" x1="1017.5" y1="210" x2="1017.5" y2="186" class="lightBorderColor--stroke" stroke-opacity="0.5"/>
        </g>
        <g id="Navigation/Menu" transform="translate(1035.000000, 188.000000)">
            <use class="primaryColorFont--stroke" xlink:href="#ellipsis-h" width="19" height="19"></use>
        </g>
        <g id="Divider Vertical_7">
            <line id="Divider_9" x1="1073.5" y1="210" x2="1073.5" y2="186" class="lightBorderColor--stroke" stroke-opacity="0.5"/>
        </g>
    </g>
    <line id="Divider_10" y1="219.5" x2="1440" y2="219.5" class="lightBorderColor--stroke"/>
</g>
</g>
`;